import core from '@gin-betting/core';
import { includes, values } from 'lodash';

import { ExtendedRouts } from 'app-constants';
import extractParentRouteFromHistory from './extractParentRouteFromHistory';

const {
    constants: { ROUTE_DIVIDER },
    services: { getHistory },
} = core;

export default function isFeaturedPage(): boolean {
    const {
        location: { pathname },
    } = getHistory();

    const parentRoute = extractParentRouteFromHistory();
    const routeOrFeatureSlug = pathname.replace(parentRoute, '');

    if (
        !routeOrFeatureSlug ||
        routeOrFeatureSlug.split(ROUTE_DIVIDER).length > 2
    ) {
        return false;
    }

    return !includes(values(ExtendedRouts), routeOrFeatureSlug);
}
